export const contactForm = () => {


    const formBtn = document.querySelector('.footer-contact-form__form input[type="submit"]')

    if (formBtn) {

        const formAttr = document.querySelector('.footer-contact-form__form').getAttribute('data-button-text-value')
        if (formAttr) {
            formBtn.setAttribute('value', formAttr)
        }
    }

}
